import { SUBSCRIPTIONS } from '@/clients'
import { laravelErrorHandler } from '@/helpers'

const getAvailableProducts = async payload => {
  const route = 'products'
  try {
    const { data } = await SUBSCRIPTIONS.get(route, { params: { coupon_code: payload } })
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const fetchPassTypes = async () => {
  const route = `passes?public=true`

  try {
    const {
      data: { data },
    } = await SUBSCRIPTIONS.get(route)
    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

const getAvailableProductBundles = async () => {
  const route = 'product-bundles'
  try {
    const {
      data: { data },
    } = await SUBSCRIPTIONS.get(route)

    return data
  } catch (error) {
    throw laravelErrorHandler(error)
  }
}

export { getAvailableProducts, fetchPassTypes, getAvailableProductBundles }
